import { useAuth } from '../contexts/AuthContext';
import App from '../App';
import Landing from '../pages/Landing';

export default function RootRoute() {
  const { user, loading } = useAuth();

  if (loading || user === undefined) {
    return <div style={{ minHeight: '100vh', background: 'black' }} data-testid="root-auth-loading" />;
  }

  return user ? <App /> : <Landing />;
}
